//
//
//
//
//
//
//
//

import HelloWorld from '../components/HelloWorld.vue'
import Start from '../components/Start.vue'
import Stats from '../components/Stats.vue'

export default {
  data: () => ({    
    LandingPage: false,
    GamePage: true,
    StatsPage: false
  }),
  name: 'Dashboard',
  components: {
    HelloWorld,
    Start,
    Stats
  },
  created() {
    console.log("DataPatchVersion"+this.$store.getters.getDataPatchVersion)
    if ( this.$store.getters.getDataPatchVersion < 2 ) {
      console.log("Patch me")
      this.$store.dispatch("patchVersion2");
    }
  },
  methods: {
    stopGame: function() {
      console.log("stopGame")
      this.LandingPage = true
      this.GamePage = false
      this.StatsPage = false
    },
    startGame: function() {
      console.log("startGame")
      this.LandingPage = false
      this.GamePage = true
      this.StatsPage = false
    },
    showStats: function() {
      console.log("showStats")
      this.LandingPage = false
      this.GamePage = false
      this.StatsPage = true
    }
  }
}
